const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Our Products", href: "#products" },
  { label: "Quality Standards", href: "#quality" },
  { label: "Certifications", href: "#certifications" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact Us", href: "#contact" },
];

const PRODUCTS_LINKS = [
  "Dooars Tea",
  "Assam Tea",
  "Lakadong Turmeric",
  "White Turmeric",
  "Indian Spices",
];

export default function Footer() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace("#", "");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0F2D1E] text-white">
      {/* Gold top accent */}
      <div className="w-full h-1 bg-gradient-to-r from-[#C9A227] via-[#F0D060] to-[#C9A227]"></div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1 – Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#home" onClick={(e) => scrollTo(e, "#home")}>
              <img
                src="https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/a21cf814587bced313e3caace3a52e8e.png"
                alt="Pandit Export Logo"
                className="h-20 md:h-24 w-auto object-contain mb-4 brightness-110"
              />
            </a>
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              Premium Indian agricultural exporter supplying high-quality Tea, Turmeric, and Spices to global markets with transparency and professionalism.
            </p>
            <p className="text-[#C9A227] text-xs font-semibold uppercase tracking-wider mb-4">Follow Us</p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-linkedin-box-fill", href: "#" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/917584050023" },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target={s.href !== "#" ? "_blank" : undefined}
                  rel="nofollow noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-[#C9A227] hover:text-[#C9A227] transition-all cursor-pointer"
                >
                  <span className="text-base">
                    <i className={s.icon}></i>
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 – Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-[#C9A227] uppercase tracking-wider mb-5">
              <a id="footer-quick-links" href="#home">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="flex items-center gap-2 text-sm text-white/60 hover:text-[#C9A227] transition-colors cursor-pointer group"
                  >
                    <span className="w-3 h-3 flex items-center justify-center text-[#C9A227] opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-s-line text-xs"></i>
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 – Products */}
          <div>
            <h4 className="text-sm font-bold text-[#C9A227] uppercase tracking-wider mb-5">
              <a id="footer-products" href="#products">Our Products</a>
            </h4>
            <ul className="space-y-3">
              {PRODUCTS_LINKS.map((p) => (
                <li key={p}>
                  <a
                    href="#products"
                    onClick={(e) => scrollTo(e, "#products")}
                    className="flex items-center gap-2 text-sm text-white/60 hover:text-[#C9A227] transition-colors cursor-pointer group"
                  >
                    <span className="w-3 h-3 flex items-center justify-center text-[#C9A227] opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-s-line text-xs"></i>
                    </span>
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 – Contact */}
          <div>
            <h4 className="text-sm font-bold text-[#C9A227] uppercase tracking-wider mb-5">
              <a id="footer-contact" href="#contact">Contact Info</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-[#C9A227] flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sm"></i>
                </span>
                <span className="text-sm text-white/60 leading-relaxed">
                  Barobisha, Jorai Road,<br />
                  Alipurduar – 736207,<br />
                  West Bengal, India
                </span>
              </li>
              <li className="flex gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-[#C9A227] flex-shrink-0">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                <a href="tel:+917679787266" className="text-sm text-white/60 hover:text-[#C9A227] transition-colors cursor-pointer">
                  +91 7679787266
                </a>
              </li>
              <li className="flex gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-[#25D366] flex-shrink-0">
                  <i className="ri-whatsapp-line text-sm"></i>
                </span>
                <a href="https://wa.me/917584050023" target="_blank" rel="nofollow noreferrer" className="text-sm text-white/60 hover:text-[#25D366] transition-colors cursor-pointer">
                  +91 7584050023
                </a>
              </li>
              <li className="flex gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-[#C9A227] flex-shrink-0">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                <a href="mailto:info@panditexport.com" className="text-sm text-white/60 hover:text-[#C9A227] transition-colors cursor-pointer">
                  info@panditexport.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Pandit Export. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            Siliguri, West Bengal, India &nbsp;|&nbsp; Exporter &amp; Trader
          </p>
        </div>
      </div>
    </footer>
  );
}
